
@if (isUserLoggedIn) {
  <div class="panel-group navUserSec d-none d-lg-block d-xl-block" >
    <ng-container *ngTemplateOutlet="leftNavigationTemplate"></ng-container>
  </div>
}
@if (isUserLoggedIn) {
  <div class="d-lg-none d-xl-none">
    @if (isOpen) {
      <div>
        <ng-container *ngTemplateOutlet="leftNavigationTemplateMobile"></ng-container>
      </div>
    }
  </div>
}
@if (isUserLoggedIn && userInfo?.webEnabled && currentSite === 'seqirusb2b-uk' || 'seqirusb2b-flu360') {
  <app-timeout-modal ></app-timeout-modal>
}
<ng-template #leftNavigationTemplate>
  @if (bannerNode | async; as item) {
    <div id="accordionsidebar">
      @for (parentNode of item.children; track parentNode) {
        <div [id]="currentSite == 'seqirusb2b-uk' ? 'banner-containeruk':'banner-container'"
          class="pl-0">
          @for (node of parentNode.children; track node; let i = $index) {
            @if (node.title != 'Start Order' && node.title != 'Place an Order') {
              <div class="panelbox card">
                @if (!node.children) {
                  <div>
                    <h4 class="dashboard-title accordion-toggle panel-heading">
                      <a class="panel-title" (click)="handleLinks(node.url, '')" [ngClass]="{'active': isActive(node.url)}"  [innerHTML]="node.title"></a>
                    </h4>
                  </div>
                }
                @if (node.children) {
                  @if (rbaflag?.RBAPermissions==true) {
                    @if (rbaflag?.hasAllLocationNotNone==true && node.title == 'Orders') {
                      <div class="panel-heading showglyphicon accordion-toggle collapsed " data-bs-toggle="collapse"
                        data-bs-parent="#accordionsidebar" [attr.data-bs-target]="'#collapse'+i" (click)="isExpanded()" [ngClass]="{'bbor':currentSite==='seqirusb2b-uk' && exp==true}">
                        <h4 class="panel-title">{{node.title}}</h4>
                        <div class="panel-icon"><i class="glyphicon" [ngClass]="glyphiconIcon" ></i></div>
                      </div>
                    }
                    @if ((rbaflag?.hasAllLocationNotNone==true || rbaflag?.hasManageFin==true)  && node.title == 'Financials & Returns') {
                      <div class="panel-heading showglyphicon accordion-toggle collapsed " data-bs-toggle="collapse"
                        data-bs-parent="#accordionsidebar" [attr.data-bs-target]="'#collapse'+i" (click)="isExpanded()" [ngClass]="{'bbor':currentSite==='seqirusb2b-uk' && exp==true}">
                        <h4 class="panel-title">{{node.title}}</h4>
                        <div class="panel-icon"><i class="glyphicon" [ngClass]="glyphiconIcon" ></i></div>
                      </div>
                    }
                    @if (node.title != 'Financials & Returns' && node.title!= 'Orders') {
                      <div class="panel-heading showglyphicon accordion-toggle collapsed " data-bs-toggle="collapse"
                        data-bs-parent="#accordionsidebar" [attr.data-bs-target]="'#collapse'+i" (click)="isExpanded()" [ngClass]="{'bbor':currentSite==='seqirusb2b-uk' && exp==true}">
                        <h4 class="panel-title">{{node.title}}</h4>
                        <div class="panel-icon"><i class="glyphicon" [ngClass]="glyphiconIcon" ></i></div>
                      </div>
                    }
                  } @else {
                    <div class="panel-heading showglyphicon accordion-toggle collapsed " data-bs-toggle="collapse" (click)="handleIconToggle(node)"
                      data-bs-parent="#accordionsidebar" [attr.data-bs-target]="'#collapse'+i" (click)="isExpanded()" [ngClass]="{'bbor':currentSite==='seqirusb2b-uk' && exp==true}">
                      <h4 class="panel-title">{{node.title}}</h4>
                      <div class="panel-icon"><i class="glyphicon" [ngClass]="glyphiconIcon" ></i></div>
                    </div>
                  }
                  @if (rbaflag?.RBAPermissions==true) {
                    @if (currentSite=='seqirusb2b-uk') {
                      <div [attr.id]="'collapse'+i" class="panel-collapse collapse">
                        <div class="panel-body" >
                          @for (innerNode of node.children; track innerNode) {
                            <ul class="desktop_sub_menu">
                              @if (node.title != 'Prescribing Information' && innerNode.title != 'Returns' && innerNode.title !='Credits' && innerNode.title !='All Invoices' && innerNode.title !='Organisation Locations') {
                                <li ><a (click)="handleLinks(innerNode.url, '')" [innerHTML]="innerNode.title" [ngClass]="{'active': isActive(innerNode.url)}"></a></li>
                              }
                              @if (node.title == 'Prescribing Information') {
                                <li><a [href]="innerNode.url" target="_blank" [innerHTML]="innerNode.title"></a></li>
                              }
                              @if (innerNode.title == 'Organisation Locations' && rbaflag?.currentUserAccountPermission !='NONE') {
                                <li><a (click)="handleLinks(innerNode.url, '')" [innerHTML]="innerNode.title"></a></li>
                              }
                              @if (innerNode.title == 'Credits'  && rbaflag?.hasManageFin == true) {
                                <li><a (click)="handleLinks(innerNode.url, '')" [innerHTML]="innerNode.title"></a></li>
                              }
                              @if (innerNode.title == 'All Invoices'  && rbaflag?.hasManageFin == true) {
                                <li><a (click)="handleLinks(innerNode.url, '')" [innerHTML]="innerNode.title"></a></li>
                              }
                              @if (innerNode.title === 'Returns' && rbaflag?.hasAllLocationNotNone == true) {
                                <div>
                                  @if (innerNode.title === 'Returns') {
                                    <li><a (click)="handleLinks(innerNode.url, '')"  id="return_links" [ngClass]="{'active': isActive(innerNode.url)}">{{innerNode.title}}</a></li>
                                  }
                                </div>
                              }
                            </ul>
                          }
                        </div>
                      </div>
                    }
                  } @else {
                    <div [attr.id]="'collapse'+i" class="panel-collapse collapse"  >
                      <div class="panel-body">
                        @for (innerNode of node.children; track innerNode) {
                          <ul class="desktop_sub_menu">
                            @if (node.title != 'Prescribing Information' && innerNode.title != 'Returns'&& innerNode.title != 'My Profile') {
                              <li><a (click)="handleLinks(innerNode.url, '')" [innerHTML]="innerNode.title" [ngClass]="{'active': isActive(innerNode.url)}"></a></li>
                            }
                            @if (node.title == 'Prescribing Information') {
                              <li><a [href]="innerNode.url" target="_blank" [innerHTML]="innerNode.title"></a></li>
                            }
                            @if (innerNode.title == 'My Profile') {
                              <li><a (click)="handleLinks('/my-profile', '')" [innerHTML]="innerNode.title" [ngClass]="{'active': isActive(innerNode.url)}"></a></li>
                            }
                            @if (innerNode.title === 'Returns') {
                              <div>
                                @if (innerNode.title === 'Returns') {
                                  <li><a (click)="handleLinks(innerNode.url, '')"  id="return_links" [ngClass]="{'active': isActive(innerNode.url)}">{{innerNode.title}}</a></li>
                                }
                              </div>
                            }
                          </ul>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            }
            @if (node.title === 'Start Order') {
              <div>
                <h4 class="startOrder-container margin-T30">
                  <a class="create-account startorder" (click)="handleLinks(node.url, '')" [innerHtml]="node.title"></a>
                </h4>
              </div>
            }
            @if (rbaflag?.RBAPermissions==true && currentSite=='seqirusb2b-uk') {
              @if (rbaflag?.showDashboardOrderUK==true ) {
                @if (node.title === 'Place an Order') {
                  <div class="dashboard-place margin-T30" >
                    <a class="p_order placeorder" (click)="handleLinks(node.url, '')"> <span class="" [innerHtml]="node.title"></span>
                  </a>
                </div>
              }
            }
          }
          @if (rbaflag?.RBAPermissions==false && currentSite=='seqirusb2b-uk') {
            @if (node.title === 'Place an Order') {
              <div class="dashboard-place margin-T30" >
                <a class="p_order placeorder" (click)="handleLinks(node.url, '')"> <span class="" [innerHtml]="node.title"></span>
              </a>
            </div>
          }
        }
      }
    </div>
  }
</div>
}
</ng-template>

<ng-template #leftNavigationTemplateMobile>
  <div id="leftNavigationTemplateMobile">
    @if (bannerNode | async; as item) {
      <div id="accordionsidebar">
        @for (parentNode of item.children; track parentNode) {
          <div id="banner-container"
            class="mob-menu pl-0">
            @for (node of parentNode.children; track node; let i = $index) {
              @if (node.title != 'Start Order') {
                <div class="panelbox card">
                  @if (!node.children) {
                    <div>
                      <h4 [ngClass]="node.title==='My Dashboard'?'dashboardUksection':''" class="dashboard-title accordion-toggle panel-heading mobile_view">
                        <a [ngClass]="node.title==='Returns'?'panel-heading-mob':''" class="panel-title panel-title-mob" (click)="handleLinks(node.url, '')" [ngClass]="{'active': isActive(node.url)}" [innerHTML]="node.title"></a>
                      </h4>
                    </div>
                  } @else {
                    <div class="panel-heading mobile_view showglyphicon accordion-toggle collapsed " (click)="handleIconToggle(node)" data-bs-toggle="collapse"
                      data-bs-parent="#accordionsidebar" [attr.data-bs-target]="'#collapse'+i">
                      <h4 class="panel-title panel-title-mob">{{node.title}}</h4>
                      <i class="glyphicon"  [ngClass]="glyphiconIcon" ></i>
                    </div>
                    <div [attr.id]="'collapse'+i" class="panel-collapse collapse">
                      <div class="panel-body">
                        @for (innerNode of node.children; track innerNode) {
                          <ul class="desktop_sub_menu desktop_sub_menu-mob">
                            @if (node.title != 'Prescribing Information') {
                              <li><a (click)="handleLinks(innerNode.url, '')" [ngClass]="{'active': isActive(innerNode.url)}" [innerHTML]="innerNode.title"></a></li>
                            }
                            @if (node.title == 'Prescribing Information') {
                              <li><a [href]="innerNode.url"
                              target="_blank" [innerHTML]="innerNode.title"></a>
                            </li>
                          }
                        </ul>
                      }
                      <!--<ul class="desktop_sub_menu desktop_sub_menu-mob" *ngFor="let innerNode of node.children;">
                      <li><a [routerLink]="innerNode.url" [innerHTML]="innerNode.title"></a></li>
                    </ul>-->
                  </div>
                </div>
              }
            </div>
          }
          @if (node.title === 'Start Order') {
            <div class="default-mob-menu-item">
              <div class="col-xs-6 mob_Menu_Item_StartOrder">
                <div class="mobstartorderbox startOrder-container-mob">
                  <a class="dashborad-create-account mobstartorderbtn" (click)="handleLinks(node.url, '')" [innerHtml]="node.title"></a>
                </div>
              </div>
              <div class="col-xs-6 mob-login-icon">
                <a class="log-in" (click)="handleLinks('/logout', '')">Log out
                  <span class="glyphicon glyphicon-log-in margin-T30"></span></a></div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>
